import { t } from 'i18next';
import type {
  NotificationHandlerContract,
  WrappedNotificationHandlerContract,
} from '../types/handlers/notification';

export function NotificationHandlerWrapper(
  notificationHandler: NotificationHandlerContract,
): WrappedNotificationHandlerContract {
  return {
    ...notificationHandler,
    error(message) {
      return notificationHandler.notify(
        t('notifications:titles.error'),
        message ?? t('errors:generic'),
        'error',
      );
    },
    warning(message) {
      return notificationHandler.notify(t('notifications:titles.warning'), message, 'warning');
    },
    success(message) {
      return notificationHandler.notify(t('notifications:titles.success'), message, 'success');
    },
    notice(message) {
      return notificationHandler.notify(t('notifications:titles.notice'), message, 'notice');
    },
  };
}
